import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { SignupForm } from '@/components/SignupForm';
import { AppNav } from '@/components/AppNav';
import { FIRST_TIME_ROUTE } from './consts';
import { LogoutButton } from '@/components/LogoutButton';
import { Footer } from '@/components/Footer';

export function Signup() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();

  const onSignupSuccess = async () => {
    // check for redirect param
    const redirect = searchParams.get('redirect');
    if (redirect) {
      navigate(redirect);
    } else {
      navigate(FIRST_TIME_ROUTE);
    }
  };

  return (
    <div className="flex min-h-screen flex-col">
      <AppNav />
      <div
        className={`relative z-[2] mx-auto flex max-w-screen-md flex-1 flex-col items-center justify-center`}
      >
        {user ? (
          <div>
            <h1 className="mb-4 text-xl">
              Logged in as {user.name || user.username || user.email}
            </h1>
            <LogoutButton />
          </div>
        ) : (
          <SignupForm onSignupSuccess={onSignupSuccess} />
        )}
      </div>
      <Footer />
    </div>
  );
}
